import SectionFirstPage from '@/components/common/SectionFirstPage';
import SectionExchangePartner from '@/components/pages/TradingSystemSolutions/SectionExchangePartner';
import SectionThreeFlipCard from '@/components/pages/TradingSystemSolutions/SectionThreeFlipCard';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TradingSystemSolutions = () => {
  const { t } = useTranslation();
  return (
    <div>
      <SectionFirstPage
        title={
          <h1>
            {t('Trading')}
            <br />
            {t('System')}
            <br />
            <span>{t('Solutions')}</span>
          </h1>
        }
        desc={t(
          'Empowering smarter trading with AI-driven algorithms, robust monitoring systems, and reliable backtesting methodologies — Warppipe delivers intelligent solutions for modern financial markets.'
        )}
      />
      <SectionExchangePartner />
      <SectionThreeFlipCard />
    </div>
  );
};

export default React.memo(TradingSystemSolutions);
